import React, { useEffect, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { purchaseNames, purchaseCountries } from "./salesData";
type PopupData = {
  name: string;
  country: string;
  minutes: number;
};
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchasePopup() {
  const [data, setData] = useState<PopupData | null>(null);
  const showNext = useCallback(() => {
    setData({
      name: randomItem(purchaseNames),
      country: randomItem(purchaseCountries),
      minutes: Math.floor(Math.random() * 14) + 2
    });
  }, []);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    let loopTimer: ReturnType<typeof setTimeout>;
    const cycle = () => {
      showNext();
      hideTimer = setTimeout(() => {
        setData(null);
        loopTimer = setTimeout(cycle, 8000 + Math.random() * 6000);
      }, 6000);
    };
    const firstTimer = setTimeout(cycle, 4000);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearTimeout(loopTimer);
    };
  }, [showNext]);
  return <div className="pointer-events-none fixed bottom-4 left-4 z-50 sm:bottom-6 sm:left-6" data-id="element-6" data-mp="1fw28cbl76zm9">
      <AnimatePresence data-id="element-7" data-mp="1awfqtpyc6x7n">
        {data && <motion.div key={`${data.name}-${data.country}-${data.minutes}`} initial={{
        opacity: 0,
        x: -40,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40
      }} transition={{
        type: "spring",
        stiffness: 300,
        damping: 26
      }} className="pointer-events-auto flex w-[290px] items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 pr-8 shadow-2xl sm:w-[330px]" role="status" data-id="element-8" data-mp="1axhceoczb23m">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-green-100" data-id="element-9" data-mp="28imxr6i451n6">
              <CheckCircle2Icon className="h-6 w-6 text-green-600" strokeWidth={2.5} data-id="element-10" data-mp="23nhao4cz5gxi" />
            </div>
            <div className="min-w-0" data-id="element-11" data-mp="2aqxlencnigeq">
              <p className="text-sm font-bold leading-tight text-[#0d1b3e]" data-id="element-12" data-mp="2fmv2wwznhst3">
                {data.name} de {data.country}
              </p>
              <p className="text-xs leading-tight text-gray-600" data-id="element-13" data-mp="2kniqf8oo7rik">
                acaba de comprar <span className="font-semibold" data-id="element-14" data-mp="2pkiuxf5vgm7k">Todos Avanzan Menos Vos</span>
              </p>
              <p className="mt-0.5 text-[11px] font-medium text-green-600" data-id="element-15" data-mp="1rzeiegimn2cp">
                hace {data.minutes} min · compra verificada
              </p>
            </div>
            <button type="button" onClick={() => setData(null)} aria-label="Cerrar notificación" className="absolute right-2 top-2 text-gray-300 transition-colors hover:text-gray-500" data-id="element-16" data-mp="21vpxfe9lq6au">
              <XIcon className="h-4 w-4" data-id="element-17" data-mp="195hpsgcoz4ai" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}